const OPTIONS = {
  results: {
    macroscopic: {
      maxPredictions: 5
    },
    dermoscopic: {
      maxPredictions: 4
    }
  },
  classify: {
    firstGateThreshold: 0.1
  },
  home: {
    disableHeroSlider: false,
  },
  snapPhoto: {
    clearBodyLocationsOnLoad: true,
  },
  patient: {
    persistAnswersOnBackButton: true,
    autoSubmit: false
  },
  bodyLocator: {
    persistAnswersOnBackButton: true
  },
  qa: {
    maxQuestions: 2
  },
  emailCapture: {
    persistOnReupload: true,
    askAgainOnSubmissionSkipped: false
  }
};

export default OPTIONS;
